<template>
	<t-badge
		:color="color"
		:isSolid="isSolid"
		:value="value"
		:size="size"
		class="pill"
		fontFamily="mono"
	>
		<slot/>
	</t-badge>
</template>

<script>
import badgeMixin from './badgeMixin';
import TBadge from './TBadge';
export default {
	name: 'TPill',
	components: { TBadge },
	mixins: [badgeMixin],
};
</script>

<style lang="scss" scoped>
.pill {
	border-radius: 1000px;
}
</style>


<docs>
## Examples

```jsx noeditor
<div style="display: inline-grid; grid-column-gap: 10px; grid-row-gap: 10px; grid-template-columns: repeat(8, auto);">
	<t-pill>1</t-pill>
	<t-pill color="red" isSolid>24</t-pill>
</div>
```
#### Example Code
```html
	<t-pill>1</t-pill>
	<t-pill color="red" isSolid>24</t-pill>
```
</docs>
